export default {
    delete_partnumber_title: "Eliminar los números de pieza",
    delete_partnumber_success_message: "Se ha eliminado el número de pieza",
    delete_partnumber_error_message: "No ha sido posible eliminar el número de pieza",
    delete_partnumber_label: "¿Está seguro de que quiere eliminar el número de pieza?",
}